
export class SchedulerTaskOrderField {
  constructor(
    public code?: number,
    public display?: string,
    public dataField?: string
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/scheduler-task-order-field.ts